import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { PatientTab } from "@/Common/Models/Patient/PatientEnums";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
import { LongTermMedicationIcon } from "@/Patient/Components/Medication/LongTermMedicationIcon";
import { Encounter } from "@/Patient/Models/MedicalSummary/Encounter";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";
import { MedicalItemViewOrigin } from "@/Patient/Models/UI/MedicalNote/Enums/MedicalItem";

import ActiveMedicationStyle from "./ActiveMedication.module.css";

interface ActiveMedicationProps {
    activeMedications: MedicationModel[];
    encounter: Encounter;
}

function ActiveMedication(props: ActiveMedicationProps): JSX.Element {
    const onActiveMedicationClick = (): void => {
        const changeTab = new LocalEvent(LocalPatientOperations.UI.ChangeVerticalTabs);
        changeTab.AddItem("value", PatientTab.Medication);
        changeTab.AddItem("MedicationViewOrigin", MedicalItemViewOrigin.Note);
        LocalEventDispatcher.dispatch(changeTab);
    };

    // start by keeping displayable medications only
    const medicationToDisplay = props.activeMedications.filter((medication: MedicationModel) => {
        let shouldDisplay = true;

        shouldDisplay =
            shouldDisplay
            &&
            (
                (
                    // finishes in the future
                    (
                        (medication.EffectiveEndDate() == null || LuxonDateTimeParser.parse(medication.EffectiveEndDate()) > LuxonDateTimeParser.parse(props.encounter.ConsultationDate))
                        && !(
                            medication.Model.CeaseEncounterId == props.encounter.Id /* if it was disactivated from the current note... */
                            && (medication.Model.CeasePrescriptionId == null || medication.Model.CeasePrescriptionId == GuidHelper.Empty().toString()) /* .... while in the medication Tab */
                        )
                    )

                    // or is expired
                    || medication.Model.SummaryDisplayStatus == 1
                )

                && !(
                    // if its a NEW med that was presribed in the current note.IsPast = 0 And RelatedEncounterId = CurrentNote
                    medication.Model.IsPast == false && medication.Model.RelatedEncounterId == props.encounter.Id
                )
            );

        return shouldDisplay;
    });

    const sortedMedicationToDisplay = medicationToDisplay.sort((curr: MedicationModel, next: MedicationModel) => {
        let result = null;

        if (curr.Model.EMRTemplateSortIndex == next.Model.EMRTemplateSortIndex) {
            result = 0;
        }
        else {
            result = (curr.Model.EMRTemplateSortIndex > next.Model.EMRTemplateSortIndex) ? 1 : -1;
        }

        return result;
    });

    const items = sortedMedicationToDisplay.map(item => {
        const expiredClassName = (item.Model.SummaryDisplayStatus == 1 ? "red-text" : "");  // expired
        const dosageRender: JSX.Element[] = [];
        const dosages = item.GetDosagesDisplay();

        dosages.forEach((dosage: string, index: number) => {
            dosageRender.push(<div key={"_dosage_" + dosage + "_" + index + "_in-active-medication"} className={expiredClassName}>{dosage}</div>);
        });

        return (
            <div key={item.Model.Id} className={`${ActiveMedicationStyle.medicationContainer}`}>
                <div
                    className="medication"
                    onClick={() => onActiveMedicationClick()}
                    data-cy="ActiveMedication-List"
                >
                    <div className="flex-container">
                        <span className="flex-container flex-col-gap-xs">
                            <LongTermMedicationIcon visible={item.isLongTerm()} dataCy="long-term-medication-icon" />
                            <a>{item.GetName(false)}</a>
                        </span>
                    </div>

                    <div className={`dosage ${ActiveMedicationStyle.dosage}`}>
                        {!dosageRender ? null : (
                            <span>
                                {dosageRender}
                            </span>
                        )
                        }
                        <span className="text-italic">
                            {item.GetInstruction() != null ? item.GetInstruction() : ""}
                        </span>
                    </div>
                </div>
            </div>
        );
    });

    return (isArrayNullOrUndefinedOrEmpty(items) ? null : (
        <div className="note-items-list">
            <div className={`flex-container ${ActiveMedicationStyle.noteItemContainer}`}>
                {items}
            </div>
        </div>
    ));
}

export { ActiveMedication };
